import { useLocation, useNavigate } from 'react-router-dom';

import { handleLogout } from '@commons/utils/hooks/authentication';
import { ORDERED_NAV_TREE } from '@commons/features';

import {
  Container,
  InpulseIcon,
  IconContainer,
  ModulesContainer,
  ModuleBox,
  ModuleIcon,
  FooterContainer
} from './styledComponents';

const Sidebar = () => {
  const navigate = useNavigate();
  const [location] = [useLocation()];

  const modules = ORDERED_NAV_TREE.filter(({ isFullScreen }) => !isFullScreen);

  const isSelected = (modulePath: string) => {
    const currentFeaturePath = location.pathname;

    return modulePath === currentFeaturePath;
  };

  return (
    <Container>
      <ModulesContainer>
        <IconContainer>
          <InpulseIcon src="images/inpulse-icon-medium.svg" />
        </IconContainer>
        <ModulesContainer>
          {modules.map(({ icon, path }) => (
            <ModuleBox isSelected={isSelected(path)} key={path} onClick={() => navigate(path)}>
              <ModuleIcon isSelected={isSelected(path)} src={icon} />
            </ModuleBox>
          ))}
        </ModulesContainer>
      </ModulesContainer>
      <FooterContainer>
        <ModuleBox isSelected onClick={handleLogout}>
          <ModuleIcon src={'/icons/logout-black-small.svg'} isSelected />
        </ModuleBox>
      </FooterContainer>
    </Container>
  );
};

export default Sidebar;
